// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3QAJj","cell":"ColumnAccessor_cell__1TBfW","firstCellAccent":"ColumnAccessor_firstCellAccent__2BOGb"};